import { LoadImage } from "./types";

export const loadImage: LoadImage = ({ imageUrl }) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Failed to load image"));
    image.src = imageUrl;
  });
};
